import { render, staticRenderFns } from "./Floors.vue?vue&type=template&id=54716767&scoped=true&"
import script from "./Floors.vue?vue&type=script&lang=js&"
export * from "./Floors.vue?vue&type=script&lang=js&"
import style0 from "./Floors.vue?vue&type=style&index=0&id=54716767&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54716767",
  null
  
)

export default component.exports